import { render, staticRenderFns } from "./DetailsScreen.vue?vue&type=template&id=39b540e6&scoped=true"
import script from "./DetailsScreen.vue?vue&type=script&lang=js"
export * from "./DetailsScreen.vue?vue&type=script&lang=js"
import style0 from "./DetailsScreen.vue?vue&type=style&index=0&id=39b540e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39b540e6",
  null
  
)

export default component.exports